import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import range from 'lodash/range';
import {FormattedMessage} from "react-intl";

const propTypes = {
  totalPages: PropTypes.number.isRequired,
  pageClick: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number,
  color: PropTypes.string
}

const defaultProps = {
  color: '',
  pageSize: 50,
  page: 1
}

// Pager class ported from Dashboard

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.state = { pager: {} };
  }

  componentDidMount() {
    // set page if items array isn't empty
    if (this.props.totalPages) {
      this.setPage(this.props.page + 1);
    }
  }

  componentDidUpdate(prevProps) {
    // reset page if items array has changed
    if (this.props.page !== prevProps.page || this.props.totalPages !== prevProps.totalPages) {
      this.setPage(this.props.page + 1);
    }
  }

  setPage(page) {
    let pager = this.state.pager;

    if (page < 1 || page > pager.totalPages) {
      return;
    }

    // get new pager object for specified page
    pager = Pagination.getPager(this.props.totalPages, page, this.props.pageSize);

    // update state
    this.setState({ pager: pager });
  }

  handlePageClick = page => {
    // call change page function in parent component
    this.props.pageClick(page);
  }

  static getPager(totalPages, currentPage, pageSize) {
    // default to first page
    currentPage = currentPage || 1;

    let startPage, endPage;
    if (totalPages <= 10) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    // create an array of pages to ng-repeat in the pager control
    const pages = range(startPage, endPage + 1);

    // return object with all pager properties required by the view
    return {
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      pages: pages
    };
  }

  render() {
    const pager = this.state.pager;
    const {totalPages} = this.props;

    if (!pager.pages || pager.pages.length <= 1) {
      // don't display pager if there is only 1 page
      return null;
    }

    return (
      <div className={classNames('pager bold',{'pager--green':this.props.color==='green'})}>
        <div className="pager-text"
             onClick={() => pager.currentPage > 1 && this.handlePageClick(1)}>
          <FormattedMessage id="contractSign.pager.firstPage"/>
        </div>
        {totalPages > 10 &&
        <div className="pager-arrow-left"
             onClick={() => pager.currentPage > 1 && this.handlePageClick(pager.currentPage - 1)}>
        </div>
        }

        <ul className="pager-list">
          {pager.pages.map((page, index) =>
            <li className={classNames('pager-list-item',{'pager-list-item--active':pager.currentPage===page})}
                key={index}
                onClick={() => this.handlePageClick(page)}>
              {page}
            </li>
          )}
        </ul>

        {totalPages > 10 &&
        <div className="pager-arrow-right"
             onClick={() => pager.currentPage < pager.totalPages && this.handlePageClick(pager.currentPage + 1)}>
        </div>
        }

        <div className="pager-text"
             onClick={() => pager.currentPage < pager.totalPages && this.handlePageClick(pager.totalPages)}>
          <FormattedMessage id="contractSign.pager.lastPage"/>
        </div>
      </div>
    )
  }
}

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;
export default Pagination;
